import { scoreColorToken } from '@/theme/tokens';

const BG: Record<string, string> = { gn: 'bg-gb', or: 'bg-ob', bl: 'bg-bb', rd: 'bg-rb' };
const TX: Record<string, string> = { gn: 'text-gn', or: 'text-or', bl: 'text-bl', rd: 'text-rd' };

interface ScorePillProps {
  value: number;
  className?: string;
}

export function ScorePill({ value, className = '' }: ScorePillProps) {
  const c = scoreColorToken(value);
  return (
    <span
      className={`inline-flex items-center rounded-md px-1.5 py-0.5 font-mono text-xs font-semibold ${BG[c]} ${TX[c]} ${className}`}
    >
      {value}
    </span>
  );
}
